import styled from "styled-components";
import { TablePageContent } from "components/TablePageLayout";
import { pxToRem } from "../../styles/utils";

export const LessonsPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled(TablePageContent)`
  margin-left: 0;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};
  padding: ${pxToRem(32)} ${pxToRem(24)};
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.ink};
`;

export const ButtonWrapper = styled.div``;

export const FileLinkContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  gap: ${pxToRem(8)};
  align-items: center;
  border: ${pxToRem(1)} solid ${({ theme }) => theme.borders.outline};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ theme }) => theme.colors.surfaceMuted};
  padding: ${pxToRem(4)};
  padding-left: ${pxToRem(8)};
  padding-right: ${pxToRem(8)};
  width: fit-content;

  &:empty {
    display: none;
  }
`;

export const BaseLinkItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
  & img {
    margin: 0;
  }
`;

export const ExpandButton = styled.button<{ isExpanded: boolean }>`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: ${({ isExpanded }) => (isExpanded ? "rotate(180deg)" : "none")};
  transition: transform 0.3s ease;
`;

/*
  Стрелка раскрытия. Проп isExpanded объявлен и передаётся давно,
  но в стилях не использовался — стрелка не поворачивалась,
  и по ней нельзя было понять, раскрыта строка или нет.
*/
export const ExpandIcon = styled.svg<{ isExpanded: boolean }>`
  width: ${pxToRem(16)};
  height: ${pxToRem(16)};
  flex: 0 0 auto;
  color: inherit;
  transform: rotate(${({ isExpanded }) => (isExpanded ? "180deg" : "0deg")});
  transition: transform 0.2s ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${pxToRem(32)};
  align-items: center;
`;